<template>
  <div class="section">
    <Breadcrumb>
      <router-link to="/">Startseite</router-link>
      <router-link to="/services">Services</router-link>
      <router-link :to="`/services/100`"><Icon icon="computer" />Antrag auf Ausbildungsförderung</router-link>
      <router-link to="/services/100/section-4">Angaben der Eltern / Ehe-/Lebenspartner</router-link>
    </Breadcrumb>
    <div class="section__header">
      <div class="headline-link wrapper">
        <div class="headline-link__headline">
          <router-link to="/services/100" class="back-button"><Icon icon="arrowLeft" /></router-link>
          <Icon icon="parents" color="detailed" class="hide-mobile"/>
          <Headline subline="Abschnitt 4" headline="Angaben der Eltern / Ehe-/Lebenspartner" />
        </div>
        <div class="headline-link__right hide-mobile">
          <div>
            <h3><b>01</b> / 07</h3>
            <div class="progress" title="Fortschritt">
              <div class="bar" style="width: 13%;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section__content wrapper margin-bottom--90 margin-top--40">
      <div class="row between-xs top-xs">
        <div class="section__content__left col-xs-12 col-md-8">

<!-- Angaben der Mutter -->
          <h3 class="margin-bottom--20">1.1 Angaben der Mutter</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="field">
            <img src="../../assets/images/sections/1.svg" alt="">
          </div>

<!-- Einkommen der Mutter -->
          <h3 class="margin-bottom--20 margin-top--60">1.2 Einkommen der Mutter</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="autofill-hint autofill-hint__top">
            <img src="../../assets/images/status/hint.svg">
            <p>Folgende Angaben lassen Sie bitte von Ihrer <b>MUTTER</b> ausfüllen. Alternativ kann Ihre Mutter diese angaben auch über ihr eigenes Bürgerkonto ergänzen. <u>Mehr dazu</u></p>
          </div>
          <div class="field">
            <img src="../../assets/images/sections/2.svg" alt="">
          </div>

<!-- Angaben des Vaters -->
          <h3 class="margin-bottom--20 margin-top--60">2.1 Angaben des Vaters</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="field">
            <img src="../../assets/images/sections/3.svg" alt="">
          </div>

<!-- Einkommen des Vaters -->
          <h3 class="margin-bottom--20 margin-top--60">2.2 Einkommen des Vaters</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="autofill-hint autofill-hint__top">
            <img src="../../assets/images/status/hint.svg">
            <p>Folgende Angaben lassen Sie bitte von Ihrem <b>VATER</b> ausfüllen. Alternativ kann Ihr Vater diese angaben auch über sein eigenes Bürgerkonto ergänzen. <u>Mehr dazu</u></p>
          </div>
          <div class="field">
            <img src="../../assets/images/sections/2.svg" alt="">
          </div>

<!-- Kinder der Eltern -->
          <h3 class="margin-bottom--20 margin-top--60">3. Kinder der Eltern</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="autofill-hint autofill-hint__top">
            <img src="../../assets/images/status/hint.svg">
            <p>Folgende Angaben lassen Sie bitte von Ihrem <b>ELTERN</b> ausfüllen. Alternativ kann Ihre Eltern diese angaben auch über ihr eigenes Bürgerkonto ergänzen. <u>Mehr dazu</u></p>
          </div>
          <div class="field">
            <img src="../../assets/images/sections/4.svg" alt="">
          </div>

<!-- Angaben des Ehe-/Lebenspartners -->
          <h3 class="margin-bottom--20 margin-top--60 blocked">4.1. Angaben des Ehepartners</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="autofill-hint autofill-hint__top">
            <img src="../../assets/images/status/hint.svg">
            <p>Da Sie als Familienstand <b>ledig</b> angegeben haben, müssen diese Angaben nicht ausgefüllt werden. Sollte es sich um einen Irrtum handeln korrigieren Sie bitte Ihre Angaben in <router-link to="/services/100/section-1"><u>Abschnitt 1</u></router-link></p>
          </div>
<!-- Einkommen des Ehe-/Lebenspartners -->
          <h3 class="margin-bottom--20 margin-top--60 blocked">4.2. Einkommen des Ehe-/Lebenspartners</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="autofill-hint autofill-hint__top">
            <img src="../../assets/images/status/hint.svg">
            <p>Da Sie als Familienstand <b>ledig</b> angegeben haben, müssen diese Angaben nicht ausgefüllt werden. Sollte es sich um einen Irrtum handeln korrigieren Sie bitte Ihre Angaben in <router-link to="/services/100/section-1"><u>Abschnitt 1</u></router-link></p>
          </div>


        </div>
        
        <Modal v-if="showFileModal" @closeModal="toggleFileModal" :outside="true">
          <Card padding="35px" class="modal-new">
            <Headline subline="Datenfeld bearbeiten" headline="Leider nicht möglich"/>
            <p>Ätsch! Diese Funktion steht in diesem Prototyp leider nicht zur Verfügung.</p>
          </Card>           
        </Modal>
        <Modal v-if="showDocModal" @closeModal="toggleDocModal" :outside="true">
          <Card padding="35px" class="modal-new">
            <Headline subline="Datenfeld bearbeiten" headline="Leider nicht möglich"/>
            <p>Ätsch! Diese Funktion steht in diesem Prototyp leider nicht zur Verfügung.</p>
          </Card>           
        </Modal>

        <!-- Sidebar -->
        <div class="section__content__sidebar col-xs-12 col-md-3">
          <div class="nav-element done"
            @click="activeField = 1"
            :class="{'selected' : activeField == 1}"
            >
            <p>1.1. Angaben der Mutter</p>
            <div class="status"></div>
          </div>
          <div class="nav-element"
            @click="activeField = 2"
            :class="{'selected' : activeField == 2}"
            >
            <p>1.2. Einkommen der Mutter</p>
            <div class="status"></div>
          </div>
          <div class="nav-element error"
            @click="activeField = 3"
            :class="{'selected' : activeField == 3}"
            >
            <p>2.1. Angaben des Vaters</p>
            <div class="status"></div>
          </div>
          <div class="nav-element"
            @click="activeField = 4"
            :class="{'selected' : activeField == 4}"
            >
            <p>2.2. Einkommen des Vaters</p>
            <div class="status"></div>
          </div>
          <div class="nav-element done"
            @click="activeField = 5"
            :class="{'selected' : activeField == 5}"
            >
            <p>3. Kinder der Eltern</p>
            <div class="status"></div>
          </div>
          <div class="nav-element disabled"
            @click="activeField = 6"
            :class="{'selected' : activeField == 6}"
            >
            <p>4.1 Angaben des Ehepartners</p>
            <div class="status"></div>
          </div>
          <div class="nav-element disabled"
            @click="activeField = 7"
            :class="{'selected' : activeField == 7}"
            >
            <p>4.2. Einkommen des Ehepartners</p>
            <div class="status"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="teaser">
      <div class="wrapper">
        <div class="row between-xs">
          <div class="col-xs-12 col-md-8">
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <router-link to="/services/100/section-3">
                  <Button type="secondary" text="Vorheriger Abschnitt"/>
                </router-link>
              </div>
              <div class="col-xs-12 col-md-6">
                <Button type="secondary" text="Eingaben prüfen"/>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <router-link to="/services/100/section-5">
              <Button type="primary" text="Weiter zum Abschluss"/>
            </router-link>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Headline from '../../components/Headline/Headline';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Icon from '../../components/Icon/Icon';
import Card from '../../components/Card/Card';
import Toggle from '../../components/formElements/Toggle/Toggle';
import Teaser from '../../components/Teaser/Teaser';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import InputText from '../../components/formElements/InputText/InputText';
import InputSelect from '../../components/formElements/InputSelect/InputSelect';
import InputAutocomplete from '../../components/formElements/InputAutocomplete/InputAutocomplete';


export default {
  name: 'Section1',
  components: {
    Headline,
    Breadcrumb,
    Icon,
    Card,
    Toggle,
    Teaser,
    Button,
    Modal,
    InputText,
    InputAutocomplete,
    InputSelect,
  },
  data() {
    return {
      showModal: false,
      showFileModal: false,
      showDocModal: false,
      activeField: 1,
      toggleAll: false,
      time: '',
      home: false,
      insurance: false,
      baby: false
    };
  },
  computed: {
    ...mapGetters({
      activeUser: 'auth/getUserSession',

    }),
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
    },
    toggleFileModal() {
      this.showFileModal = !this.showFileModal;
    },
    toggleDocModal() {
      this.showDocModal = !this.showDocModal;
    },
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Section.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Section/Section4.vue